<p-breadcrumb
  [model]="[
    { label: 'Versões', routerLink: ['/model-versions'] },
    {
      label: modelVersionId() ? 'Editar Versão' : 'Nova Versão',
      routerLink: modelVersionId()
        ? ['/model-versions/update/' + modelVersionId()]
        : ['/model-versions/create'],
    },
  ]"
  [home]="{ label: '', routerLink: ['/'], icon: 'ph-duotone ph-house text-lg' }"
/>

<form [formGroup]="formGroup" (ngSubmit)="onSubmit()" class="relative">
  <p-toolbar class="mb-5 mt-5">
    <div class="w-full flex flex-wrap justify-between items-center">
      <div>
        @if (modelVersionId()) {
          <h5 class="font-bold">Editar Versão</h5>
          <p>Confira e atualize informações</p>
        } @else {
          <h5 class="font-bold">Cadastrar Nova Versão</h5>
          <p>Preencha os campos abaixo para cadastrar</p>
        }
      </div>
      <div class="flex justify-end gap-5 items-center">
        @if (modelVersionId()) {
          <div class="w-full flex items-center gap-1">
            <label for="isActive"> Status: </label><br />
            <div class="flex gap-2 items-center">
              <p-toggleswitch formControlName="isActive" />
              {{ formGroup.get("isActive")!.value ? "Ativo" : "Inativo" }}
            </div>
          </div>
        }
        <div class="flex gap-2">
          <p-button
            label="Cancelar"
            routerLink="/model-versions"
            severity="secondary"
            rounded
            class="btn-secondary-outline"
          >
          </p-button>
          <p-button type="submit" label="Salvar" rounded></p-button>
        </div>
      </div>
    </div>
  </p-toolbar>

  <div class="flex flex-wrap lg:flex-nowrap gap-5 mt-5">
    <div class="card space-y-5 w-full">
      <h5 class="font-bold">Informações gerais</h5>

      <div class="w-full">
        <label for="name"> Nome *</label>
        <input
          pInputText
          type="text"
          formControlName="name"
          class="w-full"
          placeholder="Ex: iPhone 17 Pro Max"
        />
        <app-form-error [control]="formGroup.get('name')" />
        <app-form-server-error [control]="formGroup.get('name')" />
      </div>

      <div class="w-full">
        <label for="model"> Modelo *</label>
        <div>
          <p-select
            [options]="modelsDropdown()"
            [loading]="selectLoading()"
            formControlName="modelId"
            optionLabel="label"
            [filter]="true"
            filterBy="label"
            [showClear]="true"
            placeholder="Selecione o modelo"
            class="w-full"
          >
          </p-select>
        </div>
        <app-form-error [control]="formGroup.get('modelId')" />
        <app-form-server-error [control]="formGroup.get('modelId')" />
      </div>

      <div class="w-full">
        <label for="description"> Descrição</label>
        <input
          pInputText
          type="text"
          formControlName="description"
          class="w-full"
          placeholder="Descreva as principais características da versão"
        />
        <app-form-error [control]="formGroup.get('description')" />
        <app-form-server-error [control]="formGroup.get('description')" />
      </div>
    </div>

    <div class="card w-full h-full">
      <h5 class="font-bold">Imagem da Versão</h5>
      <p>Adicione uma imagem representativa da versão</p>

      <div class="w-full mt-5">
        <input
          pInputText
          type="file"
          class="w-full"
          accept="image/*"
          (change)="onFileSelected($event)"
          data-placeholder="Selecione a logo da versão"
        />
        <app-form-error [control]="formGroup.get('image')" />
        <app-form-server-error [control]="formGroup.get('image')" />
      </div>

      @if (selectedImagePreviewUrl()) {
        <div class="w-full mt-4">
          <label>Imagem selecionada</label>

          <div class="flex flex-col gap-1 mt-1">
            <img
              [src]="selectedImagePreviewUrl()!"
              class="w-50 h-50 border-1 rounded-lg p-2 border-gray-300 object-cover"
            />
            <p-button
              type="button"
              severity="danger"
              icon="pi pi-trash"
              class="bottom-0"
              (onClick)="removeLogo()"
              text
              title="Remover imagem"
            ></p-button>
          </div>
        </div>
      }
      @if (formGroup.get("imageUrl")?.value) {
        <div class="w-full mt-4">
          <label>Imagem salva</label>

          <div class="flex flex-col gap-1 mt-1">
            <img
              [src]="formGroup.get('imageUrl')?.value"
              class="w-50 h-50 border-1 rounded-lg p-2 border-gray-300 object-cover"
            />
            <p-button
              type="button"
              severity="danger"
              icon="pi pi-trash"
              class="bottom-0"
              (onClick)="removeLogo()"
              text
              title="Remover imagem"
            ></p-button>
          </div>
        </div>
      }
    </div>
  </div>

  @if (loading()) {
    <div
      class="absolute inset-0 z-30 flex items-center justify-center bg-black/20 backdrop-blur-sm rounded-lg"
    >
      <p-progress-spinner ariaLabel="loading"></p-progress-spinner>
    </div>
  }
</form>
<p-toast />
